exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cust-col {\n  padding-left: 12px;\n  padding-right: 12px; }\n\nselect {\n  width: 100%;\n  min-width: 60px; }\n\nselect, option {\n  width: 400px; }\n\n.delete-col {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.invalid-tip {\n  pointer-events: none;\n  color: #ebafa6 !important;\n  position: absolute !important;\n  top: 0;\n  padding-left: 12px;\n  font-size: 12px; }\n\n.ng-invalid:not(.ng-pristine) {\n  border-color: #ebafa6 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/shifts-recon/components/form-core-shift/form-field/form-field.component.scss
// module id = ../../../../../src/app/views/daily-recon/shifts-recon/components/form-core-shift/form-field/form-field.component.scss
// module chunks = main